'use client';

import { FC } from 'react';
import { RecommendationBlockStoryblok } from 'storyblok-types';
import { Button } from 'atoms/Button';
import { Container } from 'atoms/Container';
import { Link } from 'atoms/Link/Link';
import { P } from 'atoms/Typography';
import { useTranslations } from 'modules/i18n/useTranslations';
import { useMediaQuery } from 'modules/mui/hooks';
import styles from './styles.module.css';

export const RecommendationBlockBody: FC<{
  blok: RecommendationBlockStoryblok;
}> = ({ blok }) => {
  const t = useTranslations();
  const { isMobile } = useMediaQuery();

  return (
    <Container className={styles.root}>
      <div className={styles.recommendations}>
        <P className={styles.subtitle}>{blok.subtitle}</P>
        {blok?.link ? (
          <Link href={blok.link} className={styles.title}>
            {blok.title}
          </Link>
        ) : (
          <P className={styles.title}> {blok.title}</P>
        )}

        {isMobile && blok?.link && (
          <Button href={blok.link} className={styles.mobileLink}>
            {t('common.buttons.give-me')}
          </Button>
        )}
      </div>
    </Container>
  );
};
